import * as React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider, DatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';
import Skeleton from 'react-loading-skeleton';
import PropTypes from 'prop-types';

const CustomDatePicker1 = ({
  value,
  onChange,
  error,
  sx = {},
  isLoading,
  minDate,
  disabled,
}) => {
  const validValue = dayjs.isDayjs(value) ? value : null;

  return (
    <>
      {isLoading ? (
        <Skeleton height={60} />
      ) : (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            value={validValue}
            onChange={onChange}
            minDate={minDate || dayjs()} // Default to today
            renderInput={(params) => (
              <TextField
                {...params}
                error={!!error}
                helperText={error}
                fullWidth
                aria-label="Select date"
              />
            )}
            sx={{
              width: '100%',
              ...sx,
            }}
            disabled={disabled}
          />
        </LocalizationProvider>
      )}
    </>
  );
};

CustomDatePicker1.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.instanceOf(dayjs),
    PropTypes.oneOf([null]),
  ]),
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  sx: PropTypes.object,
  isLoading: PropTypes.bool,
  minDate: PropTypes.instanceOf(dayjs),
  disabled: PropTypes.bool,
};

export default CustomDatePicker1;
